import { useEffect, useState } from 'react'
import useQueryParams from './useQueryParams'

export default function useInEditMode () {
  const queryParams = useQueryParams()
  const [inEditMode, setInEditMode] = useState('epieditmode' in queryParams && (queryParams.epieditmode === 'True' || queryParams.epieditmode === 'true'))
  useEffect(() => setInEditMode('epieditmode' in queryParams && (queryParams.epieditmode === 'True' || queryParams.epieditmode === 'true')), [queryParams])
  return inEditMode
}
